import { useNavigate } from "@tanstack/react-router";
import { endpoints } from "../api.js";
import { useResource } from "../useResource.js";
import { Dashboard } from "./Dashboard.js";
import { Failed, Loading } from "./Loading.js";

/** The dashboard, reading one endpoint — four panels are one screen, not four requests. */
export function DashboardScreen() {
  const navigate = useNavigate();
  const data = useResource(() => endpoints.dashboard(), []);

  if (data.error) return <Failed error={data.error} retry={data.reload} />;
  if (data.loading || !data.data) return <Loading what="the dashboard" />;

  return (
    <Dashboard
      queue={data.data.queue}
      recent={data.data.recent}
      top={data.data.top}
      counters={data.data.counters}
      onRate={() => void navigate({ to: "/rate" })}
    />
  );
}
